export const SHIP_ORDER_PATH = 'https://us-central1-all-about-extract-admin.cloudfunctions.net/shipOrder';


// WEBPACK FOOTER //
// ./src/actions/ServicePath.js